import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 16,
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
  },
  top: {
    display: "flex",
    marginBottom: 12,
    [theme.breakpoints.up("md")]: {
      flex: 1,
      marginBottom: 0,
    },
  },
  check: {
    flex: "0 0 32px",
    display: "flex",
    alignItems: "center",
  },
  search: {
    flex: 1,
  },
  searchField: {
    [theme.breakpoints.up("md")]: {
      width: 270,
    },
  },
  selected: {
    flex: 1,
    display: "flex",
    alignItems: "center",
  },
  deleteButton: {
    marginRight: 16,
  },
  bottom: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      flex: 1,
      justifyContent: "flex-end",
    },
  },
  sort: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
}));
